import { IconCheck } from '@belong/icons';
import { Text } from '@belong/ui';

type TableRowProps = {
  header: string;
  description: string;
  belong?: boolean;
  traditional_property_management?: boolean;
  tech_property_management?: boolean;
};

export const TableRow = ({
  header,
  belong,
  traditional_property_management,
  tech_property_management,
  description,
}: TableRowProps) => {
  return (
    <tr className="border-gray border border-solid">
      <td className="border-gray p-xs sm:p-sm border border-solid text-left">
        <Text variant="p1" fontWeight="semibold" className="sm:body ">
          {header}
        </Text>
        <Text variant="p1" className="sm:body">
          {description}
        </Text>
      </td>
      <td className="border-gray bg-navy-translucent-light  border border-solid align-middle">
        {belong && (
          <div className="flex w-full justify-center">
            <IconCheck width={20} className="text-green" />
          </div>
        )}
      </td>
      <td className="border-gray border border-solid align-middle">
        {traditional_property_management && (
          <div className="flex w-full justify-center">
            <IconCheck width={20} className="text-green" />
          </div>
        )}
      </td>
      <td className="align-middle">
        {tech_property_management && (
          <div className="flex w-full justify-center">
            <IconCheck width={20} className="text-green" />
          </div>
        )}
      </td>
    </tr>
  );
};
